<template>
  <div class="topfans-page-brightpoint">
    <div class="topfans-section app-basic-layout-wrapper">
      <h3 class="title font-30">产品亮点</h3>
      <div class="body">
        <div class="icon-tabs">
          <template v-for="(tab, index) in tabs">
            <div
              class="tab"
              :class="{ active: activeIndex === index }"
              :key="tab.id"
              @click="changeSlide(index)"
            >
              <div class="icon-image">
                <img
                  class="active-img"
                  :src="
                    require(`@/assets/img/topfans/brightpoint_icon_active_${tab.id}.png`)
                  "
                  alt=""
                />
                <img
                  class="default-img"
                  :src="
                    require(`@/assets/img/topfans/brightpoint_icon_${tab.id}.png`)
                  "
                  alt=""
                />
              </div>
              <h3
                class="font-20"
                :class="{ 'font-color-notice': activeIndex !== index }"
              >
                {{ tab.name }}
              </h3>
            </div>
            <div v-if="index < 2" class="t-line" :key="'line' + tab.id"></div>
          </template>
        </div>
        <div class="tab-content">
          <swiper
            ref="tabSwiper"
            :options="swiperOptions"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="item in tabs" :key="item.id">
              <img
                :src="
                  require(`@/assets/img/topfans/brightpoint_${item.id}.png`)
                "
                alt=""
              />
            </swiper-slide>
            <div slot="button-prev" class="swiper-button-prev">
              <i class="iconfont icon-zuocefanhuijiantou"></i>
            </div>
            <div slot="button-next" class="swiper-button-next">
              <i class="iconfont icon-youcefanhuijiantou"></i>
            </div>
          </swiper>
        </div>
      </div>
      <div class="footer">
        <a
          href="https://weibo.com/u/3587960280"
          class="zixun-btn"
          target="_blank"
        >
          免费咨询，开始使用
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'topfans-page-brightpoint',
  data() {
    return {
      activeIndex: 0,
      tabs: [
        {
          id: 1,
          name: '内容加热'
        },
        {
          id: 2,
          name: '营销推广'
        },
        {
          id: 3,
          name: '帮上头条'
        }
      ],
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.tabSwiper.swiper
    }
  },
  methods: {
    changeSlide(index) {
      this.swiper.slideTo(index)
    },
    onSlideChange() {
      this.activeIndex = this.swiper.activeIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.topfans-page-brightpoint {
  background-color: #f4f5f7;
  .topfans-section {
    & > .title {
      &:after {
        display: none;
      }
    }
  }
  .icon-tabs {
    display: flex;
    width: 630px;
    margin: 0 auto 20px;
    justify-content: space-between;
    .icon-image {
      width: 64px;
      height: 64px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
    .tab {
      cursor: pointer;
      text-align: center;
      h3 {
        margin-top: 9px;
      }
      .active-img {
        display: none;
      }
      &:hover,
      &.active {
        .active-img {
          display: inline;
        }
        .default-img {
          display: none;
        }
      }
    }
    .t-line {
      height: 1px;
      width: 153px;
      margin-top: 32px;
      background-color: rgba(142, 144, 145, 0.1);
    }
  }
  .swiper-slide {
    img {
      width: 100%;
    }
  }
  .swiper-button-next,
  .swiper-button-prev {
    background-color: #ffffff;
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-image: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: $text-color-notice;
    &:hover {
      background-color: $danger-color;
      color: #ffffff;
    }
    &.swiper-button-disabled {
      opacity: 0.65;
      background-color: #ffffff;
      color: rgba(142, 144, 145, 0.45);
    }
  }
  .swiper-button-next {
    right: 0;
  }
  .swiper-button-prev {
    left: 0;
  }
  .footer {
    text-align: center;
    margin-top: 48px;
    .zixun-btn {
      background-color: $danger-color;
      color: #ffffff;
      display: inline-block;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      border-radius: 24px;
      padding: 0 32px;
    }
  }
}
</style>
